// src/pages/NotFoundPage.js
import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
	return (
		<div className="flex flex-col items-center justify-center h-screen bg-gray-100">
			<h1 className="text-6xl font-bold text-blue-700 mb-4">404</h1>
			<h2 className="text-2xl font-semibold text-gray-800 mb-4">Pagina non trovata</h2>
			<p className="text-gray-600 text-center mb-6">
				La pagina che stai cercando non esiste o è stata spostata.
			</p>
			<Link
				to="/"
				className="bg-blue-700 text-white py-2 px-4 rounded-md hover:bg-blue-800 transition"
			>
				Torna alla home
			</Link>
		</div>
	);
}
